import React, {useEffect} from 'react'
import EnrollmentView from '../../components/views/EnrollmentView';
import OpenedSidebar from "../../components/openedSidebar"
import { connect} from 'react-redux';
import { dashboardActions } from '../../redux-utils/actions/dashboard-actions';
import Loader from '../../components/Loader';
import { useAuth } from '../../custom-hooks/useAuth';
import { useSelector } from 'react-redux';
import ClosedSidebar from '../../components/closedSidebar';



const { allParticipantAction } = dashboardActions;

function EnrollmentData({allParticipantResult}) {
  const data = allParticipantResult?.allParticipantData || [];
  const isOpened = useSelector((state) => state.sidebarState.isOpen);
  if(allParticipantResult.allParticipantData && allParticipantResult.allParticipantData.length > 0) {
    return (
      <EnrollmentView 
        data={data}
      />
    )
  }

  return (
    (allParticipantResult.status === "" || allParticipantResult.status === "all_participant_fetch_start") ? (
      <div className="bg-[#F9F9F9] font-sans flex">
        {isOpened ? <OpenedSidebar />  :  <ClosedSidebar/>}
        <Loader />
      </div>
    ) :
    (
        <EnrollmentView 
          data={data}
        />
    )
  ) 
}

const areEqual = (prevProps, nextProps) => {
  return prevProps.allParticipantResult.allParticipantData === nextProps.allParticipantResult.allParticipantData
};

const EnrollmentMemo = React.memo(EnrollmentData, areEqual)

function Enrollment(props) {
    const { 
    allParticipantDispatchAction,
    allParticipantResult
  } = props;

  const { getLogin } = useAuth();
  const loginStorage = JSON.parse(getLogin());

  useEffect(() => {
    const allParam = {
      token: loginStorage && loginStorage.loginData.data.token
    }
    allParticipantDispatchAction(allParam);

  }, [])

  return (
    <>
      <EnrollmentMemo 
        allParticipantDispatchAction={allParticipantDispatchAction} 
        allParticipantResult={allParticipantResult}
      />
    </>
  )
}

const mapStateToProps = (state) => ({
  allParticipantResult: state.dashboardState
});

const mapDispatchToProps = dispatch => ({
  allParticipantDispatchAction: (param) => dispatch(allParticipantAction(param)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Enrollment);